export const TYPES = {
  UserAgentUseCase: Symbol.for("UserAgentUseCase"),
  UserAgentRepository: Symbol.for("UserAgentRepository"),
  ProjectUseCase: Symbol.for("ProjectUseCase"),
  ProjectRepository: Symbol.for("ProjectRepository"),
  PostUseCase: Symbol.for("PostUseCase"),
  PostRepository: Symbol.for("PostRepository"),
  AssetRepository: Symbol.for("AssetRepository"),
  MarkdownService: Symbol.for("MarkdownService"),
};
